module.exports = __webpack_public_path__ + "img/u8992.8099fffe.svg";